export default function getCartHeader(state, siteKey) {
	let header = siteKey;

	if (state.cart.shoppertrack) {
		header += ":" + state.cart.shoppertrack;
	}

	// Auth header (site_key OR site_key:cart OR site_key:customer:cart)
	return header;
}



// WEBPACK FOOTER //
// ./src/store/utils/cartHeader.js